import { defineStore } from 'pinia';
import depotApi from '@api/depot';
import { cloneDeep } from 'lodash';
import { invalidateResourceFilterCache } from '@composables/useResourceFilterOptions';

export const useDepotStore = defineStore('depot', {
    state: () => {
        return {
            loading: false,
            data: {
                address: '',
                type: null,
            },
            collection: [],
            serverData: {},
            types: [],
            createValues: {
                active: true,
                type: null,
                capacity_management_type: 'CALCULATED',
                max_capacity: null,
            },
        };
    },
    getters: {},
    actions: {
        async index(params = {}) {
            try {
                const { data } = await depotApi.index(params);
                this.collection = data.data;
            } catch (error) {
                this.loading = false;
                throw error;
            }
        },

        async create(depot) {
            try {
                this.loading = true;
                const { data } = await depotApi.create(depot);
                this.mapResponseValues(data.depot);
                invalidateResourceFilterCache(['depots']);
                this.loading = false;
            } catch (error) {
                this.loading = false;
                throw error;
            }
        },

        async retrieve(depotId) {
            try {
                this.loading = true;
                const { data } = await depotApi.retrieve(depotId);
                this.mapResponseValues(data.depot);
                this.loading = false;
            } catch (error) {
                this.loading = false;
                // let the form component display the error
                throw error;
            }
        },

        async update(depotId, depot) {
            try {
                this.loading = true;
                const { data } = await depotApi.update(depotId, depot);
                this.mapResponseValues(data.depot);
                invalidateResourceFilterCache(['depots']);
                this.loading = false;
            } catch (error) {
                this.loading = false;
                throw error;
            }
        },

        async fetchTypes() {
            try {
                const { data } = await depotApi.types();
                this.types = data;
            } catch (error) {
                console.error('Error fetching depot types:', error);
                throw error;
            }
        },

        mapResponseValues(depot) {
            this.serverData = cloneDeep(depot);
            this.data = depot;
            this.data.address = depot.address.formatted;
        },
    },
});
